import type { LinksLookup } from 'src/translators/links-lookup';

// When modifying an existing entry here, you might need to add an NGINX redirect from the old URL to the new one,
// in france.template
export const linksLookup: LinksLookup = {
  'book-a-tour': 'reservez-votre-visite',
  'club-facilities': 'installations-du-club',
  'club-treatments': 'club-treatments',
  'club-fitness': 'club-fitness',
  'creche': 'creche',
  'exercise-classes': 'cours-collectifs',
  'gym': 'plateau-musculation',
  'sports': 'sports',
  'kids-classes': 'cours-enfants',
  'children': 'enfants',
  'pools': 'piscines',
  'spa': 'spa',
  'tennis': 'tennis',
  'enquire-now': 'se-renseigner',
  'enquiry-form': 'se-renseigner',
  'family-and-kids': 'famille-et-enfants',
  'golf': 'golf',
  'join-now': 'sinscrire-maintenant',
  'manage-your-tour': 'gerer-votre-visite',
  'membership-trial': 'abonnement-decouverte',
  'relax-and-socialise': 'se-detendre-et-socialiser',
  'timetable': 'horaries',
  'yoga': 'yoga',
  'blaze': 'blaze',
  'personal-training': 'coaching-individuel',
  'join': 'inscrivez-vous',
  // If this link is changed, we should:
  // - Update nginx OJ route handling
  // - Update MSS/Common in the backend
  // - Update the links stored in CC e.g. see DLLABS-10292 (or add an nginx redirect from the old route)
  'join-online': 'inscrire-en-ligne',
  // TODO Redesign: Check over these translations
  'membership-type': 'type-dadhesion',
  'members': 'membres',
  'personal-details': 'informations-personnelles',
  'your-price': 'votre-tarif',
  'treatments': 'face-body-spa',
  'global-enquire-now': 'se-renseigner',
  'memberships': 'adhesion',
  'terms-and-conditions': 'termes-et-conditions',
  'policy': 'politique',
  'careers': 'carrieres',
  'digital-signature': 'signature-numerique',
  'young-adult': 'jeune-adulte',
  'family': 'famille',
};
